import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment as env } from '../../environments/environment';

export interface PrintingSettings {
  printPreparationTickets?: boolean;
}

@Injectable({ providedIn: 'root' })
export class PrintingSettingsService {
  private readonly http = inject(HttpClient);
  private readonly base = `${env.apiUrl}/restaurants`;

  get(restaurantId: string): Observable<PrintingSettings> {
    return this.http.get<PrintingSettings>(`${this.base}/${restaurantId}`);
  }

  update(restaurantId: string, payload: PrintingSettings): Observable<PrintingSettings> {
    return this.http.patch<PrintingSettings>(`${this.base}/${restaurantId}`, payload);
  }
}
